import React, { FC } from 'react';

import { UseQueryResult } from '@tanstack/react-query';
import classNames from 'classnames';

import { EvSection, TABLE_SR_SUMMARY_IDS } from '@evinced-private/ui-common';

import { MFA_DASHBOARD_PAGE_TABLE_SECTION_ID } from 'data-automation-ids/MfaDashboardAutomationIds';
import { TMfaSessionsResult } from 'src/apps/mfa/types/MfaDashboardServiceTypes';
import { PlatformTable } from 'src/common/components/platform-table/PlatformTable';
import { MFA_SESSIONS_TABLE_ID } from 'src/common/pages/dashboards-container/dashboard_consts';

import { getMfaSessionsColumns } from './MfaSessionsTableHelper';

import './MfaSessionsTable.scss';

interface IMfaDashboardTableProps {
	sessionsQuery: UseQueryResult<TMfaSessionsResult>;
	unfilteredTotal: number;
}

const TABLE_KEY_FIELD = 'sessionId';
const TABLE_TITLE = 'MFA Sessions';
const TABLE_CAPTION = 'MFA Sessions table';
const DATA_TYPE = 'sessions';

export const MfaSessionsTable: FC<IMfaDashboardTableProps> = ({
	sessionsQuery,
	unfilteredTotal
}) => {
	const total: number = sessionsQuery.data?.total ?? 0;

	const isTableLoading =
		sessionsQuery.isLoading ||
		sessionsQuery.isPreviousData ||
		(sessionsQuery.isStale && sessionsQuery.isRefetching);

	return (
		<EvSection
			ariaLabel="Mobile Flow Analyzer sessions table"
			ariaLive="polite"
			ariaDescribedby={TABLE_SR_SUMMARY_IDS}
			skipLinkId="main-section"
			className={classNames('dashboard-section', 'mfa-sessions-table')}
			dataAutomationId={MFA_DASHBOARD_PAGE_TABLE_SECTION_ID}
		>
			<PlatformTable
				isTableLoading={isTableLoading}
				tableId={MFA_SESSIONS_TABLE_ID}
				tableData={sessionsQuery.data?.rows}
				totalPaginationableResults={total}
				totalCount={unfilteredTotal}
				persistTableState
				columns={getMfaSessionsColumns()}
				options={{
					keyField: TABLE_KEY_FIELD,
					title: TABLE_TITLE,
					caption: TABLE_CAPTION,
					pagination: true,
					dataType: DATA_TYPE,
					remote: true
				}}
			/>
		</EvSection>
	);
};
